import { Button, Tooltip, Typography } from "@mui/material";
import { GridColDef, GridRenderCellParams, GridValueGetter } from "@mui/x-data-grid-premium";
import moment from "moment";
import { IconButton } from "@mui/material";
import {
  ContentCopy,
  DeleteOutline,
} from "@mui/icons-material";
import { documentTemplateStatus } from "../viewDatasheet/basicDetails";
import { PublishedIcon } from "../../images/svg/publishedIcon";
import { WIPIcon } from "../../images/svg/WIPIcon";

export const TableColumn = (
  onDelete: (row: any) => void,
  view: (row: any) => void,
  duplicateTemplate: (row: any) => void,
  hasAccess: boolean,
  getPath: (id: string) => string,
  updatePublishStatus: (row: any) => void,
) => {
  let columns: GridColDef[] = [
    {
      field: "sequence_id",
      headerName: "Check List ID",
      width: 150,
      renderCell: (params: GridRenderCellParams) => {
        if (params.rowNode.type === "group") {
          return params.value;
        }
        return (
          <Typography
            id="view-checklist"
            onClick={(e) => {
              e.preventDefault();
              if (hasAccess) {
                view(params.row);
              }
            }}
            variant="body2"
            color="primary"
            component={"a"}
            href={hasAccess ? getPath(params.row?._id) : undefined}
            sx={hasAccess ? { color: "blue", cursor: "pointer", textDecoration: "underline" } : { textDecoration: "none" }}
          >
            {params.row.sequence_id}
          </Typography>
        );
      },
    },
    {
      field: "name",
      headerName: "Check List Name",
      width: 230,
      renderCell: (params: GridRenderCellParams) => {
        if (params.rowNode.type === "group") {
          return params.value;
        }
        return <Typography variant="body2">{params.row?.name ?? ""}</Typography>;
      },
      valueGetter: (value, row, column, apiRef): GridValueGetter => {
        return row?.name ?? "";
      },
    },
    {
      field: "description",
      headerName: "Check List Description",
      width: 230,
      renderCell: (params: GridRenderCellParams) => {
        if (params.rowNode.type === "group") {
          return params.value;
        }
        return <Typography variant="body2">{params.row?.description ?? ""}</Typography>;
      },
      valueGetter: (value, row, column, apiRef): GridValueGetter => {
        return row?.description ?? "";
      },
    },
    // {
    //   field: "tags_info",
    //   headerName: "Tags",
    //   width: 230,
    //   renderCell: (params: GridRenderCellParams) => {
    //     if (params.rowNode.type === "group") {
    //       if (params.rowNode.groupingField === "type") {
    //         return params.rowNode.groupingKey;
    //       }
    //       return "";
    //     }
    //     return (
    //       (<Stack
    //         spacing={1}
    //         direction={"row"}
    //         id={"tagsChip"}
    //         sx={{
    //           width: "100%",
    //         }}>
    //         {params.row.tags_info
    //           ?.filter((_: any) => _.tag_group_canonical_name === TAG_CANONICAL_NAMES.cl_general)
    //           .map((tag: any) => (
    //             <Tooltip
    //               title={tag?.tag_name}
    //               key={tag?.tag_name}
    //               placement={"top"}
    //             >
    //               <Chip
    //                 variant="outlined"
    //                 sx={{
    //                   borderColor: tag.tag_group_color,
    //                   backgroundColor: tag.tag_group_color,
    //                   color: `${hexToGrayscale(tag.tag_group_color) > 150
    //                     ? "rgba(0, 0, 0, 0.87)"
    //                     : "#FFFFFF"
    //                     }`,
    //                 }}
    //                 size={"small"}
    //                 label={tag?.tag_name ?? ""}
    //               />
    //             </Tooltip>
    //           ))}
    //       </Stack>)
    //     );
    //   },
    //   valueGetter: (value, row, column, apiRef): GridValueGetter => {
    //     return (
    //       row?.tags_info
    //         ?.filter((t: TagInfo) => t.tag_group_canonical_name === TAG_CANONICAL_NAMES.cl_general)
    //         .map((t: TagInfo) => t?.tag_name)
    //         .join(",") ?? ""
    //     );
    //   },
    // },
    {
      field: "status",
      headerName: "Status",
      width: 90,
      renderCell: (params: GridRenderCellParams) => {
        return (
          documentTemplateStatus[1].label === params?.row?.status ? (
            <Button disableRipple disableFocusRipple sx={{ cursor: "default", '&:hover': { backgroundColor: 'transparent' } }}>
              <Tooltip
                title="Published"
                children={<div><PublishedIcon /></div>}
              />
            </Button>
          ) : (
            <Button disableRipple disableFocusRipple id="publish-checklist">
              <Tooltip
                title={hasAccess ? "Work in progress, click to publish the item" : "Not Published"}
                children={
                  <div><WIPIcon onClick={() => hasAccess ? updatePublishStatus(params.row) : false} /></div>
                }
              />
            </Button>
          )
        );
      },
    },
    {
      field: "created_user",
      headerName: "Created By",
      width: 150,
      renderCell: (params: GridRenderCellParams) => {
        if (params.rowNode.type === "group") {
          return params.value;
        }
        return (
          <Typography variant="body2">{params.row?.created_user}</Typography>
        );
      },
    },
    {
      field: "created_time",
      headerName: "Date & Time",
      width: 180,
      renderCell: (params: GridRenderCellParams) => {
        if (params.rowNode.type === "group") {
          return params.value;
        }
        return (
          <Typography variant="body2">
            {moment(params.row?.created_time).format("lll")}
          </Typography>
        );
      },
    },
    {
      field: "modified_user",
      headerName: "Updated By",
      width: 150,
      renderCell: (params: GridRenderCellParams) => {
        if (params.rowNode.type === "group") {
          return params.value;
        }
        return (
          <Typography variant="body2">{params.row?.modified_user}</Typography>
        );
      },
    },
    {
      field: "modified_time",
      headerName: "Date & Time",
      width: 250,
      renderCell: (params: GridRenderCellParams) => {
        if (params.rowNode.type === "group") {
          return params.value;
        }
        return (
          <Typography variant="body2">
            {params.row.modified_time
              ? moment(params.row.modified_time).format("lll")
              : ""}
          </Typography>
        );
      },
    }
  ];

  if (hasAccess) {
    columns = [columns[0], {
      field: "duplicate",
      headerName: "Duplicate",
      resizable: true,
      width: 90,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Tooltip title="Make a Duplicate">
            <IconButton
              sx={{ margin: "auto" }}
              onClick={() =>
                duplicateTemplate(params?.row)
              }
            >
              <ContentCopy fontSize="small" />
            </IconButton>
          </Tooltip>
        );
      },
    }, ...columns.slice(1), {
      field: "delete",
      headerName: "Delete",
      width: 100,
      renderCell: (params: GridRenderCellParams) => {
        const isPublished = documentTemplateStatus[1].label === params?.row?.status;

        return (
          <Tooltip title={isPublished ? `${params?.row?.sequence_id} is published, you are not allowed to delete` : `Click to delete the Checklist ${params?.row?.sequence_id}`}>
            <IconButton disableRipple={isPublished} onClick={() => isPublished ? () => { } : onDelete(params.row)}>
              <DeleteOutline color={isPublished ? "disabled" : "error"} id="delete-checklist-icon" />
            </IconButton>
          </Tooltip>
        );
      },
      disableColumnMenu: true,
      sortable: false,
    },]
  }

  return columns;
};
